import { render, staticRenderFns } from "./accessGroupsList.vue?vue&type=template&id=2b3ca810&scoped=true&"
import script from "./accessGroupsList.vue?vue&type=script&lang=js&"
export * from "./accessGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3ca810",
  null
  
)

export default component.exports